import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map-route-pickup",
  "use": "icon-map-route-pickup-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-map-route-pickup\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M24 24H0V0h24z\" /><g transform=\"rotate(-180 11 11)\"><circle stroke=\"#000\" stroke-width=\"2\" fill=\"#FFF\" cx=\"10\" cy=\"10\" r=\"9\" /><path d=\"m9.998 4.904 4.243 4.242-1.414 1.415L11 8.734V15H9V8.73l-1.83 1.83-1.414-1.414 4.242-4.242z\" fill=\"#000\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol